import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { reviewsData } from '../data/mock';
import { Card } from './ui/card';
import { Button } from './ui/button';

const Reviews = () => {
  const { language, t } = useLanguage();

  const StarRating = ({ rating }) => (
    <div className="flex gap-1">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={20}
          fill={i < rating ? 'var(--amber)' : 'none'}
          stroke={i < rating ? 'var(--amber)' : 'var(--brown-medium)'}
        />
      ))}
    </div>
  );

  return (
    <section id="reviews" className="py-20" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="mb-3">{t.reviews.title}</h2>
          <p className="text-lg mb-8" style={{ color: 'var(--brown-medium)' }}>
            {t.reviews.subtitle}
          </p>
          
          {/* Rating Overview */}
          <div className="inline-flex flex-col items-center gap-2 p-6 rounded-xl" style={{ backgroundColor: 'var(--beige-warm)' }}>
            <div className="text-5xl font-bold" style={{ color: 'var(--brown-dark)' }}>4.6</div>
            <StarRating rating={5} />
            <p className="text-sm" style={{ color: 'var(--brown-medium)' }}>
              {t.reviews.basedOn} 43 {t.reviews.googleReviews}
            </p>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {reviewsData.map((review) => (
            <Card key={review.id} className="p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h4 className="font-semibold mb-1" style={{ color: 'var(--brown-dark)' }}>
                    {review.name}
                  </h4>
                  <StarRating rating={review.rating} />
                </div>
              </div>
              <p className="text-base leading-relaxed" style={{ color: 'var(--brown-medium)' }}>
                {language === 'ro' ? review.text : review.textEn}
              </p>
            </Card>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Button
            asChild
            size="lg"
            className="btn-secondary"
          >
            <a
              href="https://www.google.com/maps/search/saloon+beer+chisinau"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
            >
              {t.reviews.viewAll}
              <ExternalLink size={18} />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Reviews;